"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/features/auth";

export default function AdminRootLayout({ children }: { children: React.ReactNode }) {
  const { loading, isAuthenticated, isSuperadmin, isCompanyAdmin } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    const isLoginPage = window.location.pathname === "/admin/login";
    if (!isAuthenticated && !isLoginPage) {
      router.replace("/admin/login");
    } else if (isAuthenticated && isLoginPage) {
      router.replace(isSuperadmin ? "/admin/dashboard" : "/company/dashboard");
    } else if (isAuthenticated && !isSuperadmin && !isLoginPage) {
      router.replace("/company/dashboard");
    }
  }, [loading, isAuthenticated, isSuperadmin, isCompanyAdmin, router]);

  return <>{children}</>;
}
